
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as _ref_Li93ZWJhZGItYnJpZGdlLmpz_ from './webadb-bridge.js';
import * as _ref_QGpzLWpvZGEvY29yZQ_ from '@js-joda/core';
import { instantiate } from './composeApp.uninstantiated.mjs';


const exports = (await instantiate({
    './skiko.mjs': Li9za2lrby5tanM,
    './webadb-bridge.js': _ref_Li93ZWJhZGItYnJpZGdlLmpz_,
    '@js-joda/core': _ref_QGpzLWpvZGEvY29yZQ_
})).exports;

export const {
memory,
_initialize
} = exports


